// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { i18n } from '../../index'
import sumBy from 'lodash/sumBy'
import cn from 'classnames'
import css from './IncentivesPanel.css'
type BarRowProps = {
  isActual?: boolean
  actual: number
  target: number
  unit: string | null | undefined
  type: string
}
type CounterProps = {
  type: string
  actual: number
  target: number
  unit: string | null | undefined
}
type CountersProps = {
  dailyManagement: Record<string, any>
  units: string
}

const percent8 = (a: number, t: number): number => Math.round((a / t) * 100)

const BarRow = ({ isActual = false, actual, target, unit, type }: BarRowProps) => {
  const BAR_MAX = target
  let barValue = 5

  if (target === 0 || actual === 0 || actual < 0) {
    barValue = 5 // Default state
  } else if (actual >= BAR_MAX) {
    barValue = 80 // When target reached, set it to full width
  } else {
    barValue += percent8(actual, target) * 0.8 // All cases in between
  }

  const barWidth = `${barValue}%`
  const targetReached = actual > 0 && target > 0 && actual >= target

  const getClassNameForActualSales = (val: number): string => {
    if (!val) return css.redBar
    if (val <= 79) return css.redBar
    if (val >= 80 && val <= 99) return css.yellowBar
    return css.greenBar
  }

  const getBarClass = (target, cond, valueForClass) => {
    if (target === 0) return css.noBar
    return cond ? css.bar : getClassNameForActualSales(valueForClass)
  }

  return (
    <div className={css.barRow}>
      <div
        className={getBarClass(target, targetReached || !isActual, percent8(actual, target))}
        style={{
          width: isActual ? barWidth : '90%',
        }}
      ></div>

      <span
        className={cn({
          [css.noBarText]: target === 0,
          [css.barText]: target > 0,
        })}
      >
        {isActual && `${actual} / ${target}`}
      </span>
    </div>
  )
}

const Counter = ({ type, actual, target, unit }: CounterProps) => {
  const actualUnits = type === 'incentiveSales' ? unit : 'kpl'
  return (
    <div className={css.counter}>
      <Typography variant='subtitle1' className={css.counterTitle}>
        {i18n.t(`employeeCard.${type}`)}
      </Typography>
      <div className={css.rowContainer}>
        <div className={css.rowUnits}>
          <span className={css.type}>
            {`${i18n.t('employeeCard.stationActual')} / ${i18n.t('employeeCard.target')}`}
          </span>
          <span>{actualUnits}</span>
        </div>

        <div
          style={{
            position: 'relative',
          }}
        >
          <BarRow isActual actual={actual} target={target} unit={unit} type={type} />
          <BarRow actual={actual} target={target} unit={unit} type={type} />
        </div>
      </div>
    </div>
  )
}

const Counters = ({ dailyManagement, units }: CountersProps) => {
  const targets = dailyManagement.salesIncentiveTargets
  const thumbsUpTargets = dailyManagement.thumbsUpTargets
  return (
    <Paper className={css.counterContainer}>
      <Counter
        type='incentiveSales'
        actual={sumBy(targets, (item) => item.actual)}
        target={sumBy(targets, (item) => item.target)}
        unit={units}
      />
      <Counter
        type='thumbsUpServices'
        actual={sumBy(thumbsUpTargets, (item) => item.actual)}
        target={sumBy(thumbsUpTargets, (item) => item.target)}
        unit={units}
      />
    </Paper>
  )
}

export default Counters
